"use client";

import Image from "next/image";
import { useRouter, useSearchParams } from "next/navigation";
import { useState } from "react";

import arrowLeft from "./arrow_left.png";
import arrowRight from "./arrow_right.png";
const styles = new Proxy({"Pagination":"Pagination-74b5f","Arrow":"Arrow-74b5f","Dots":"Dots-74b5f","Dot":"Dot-74b5f","DotActive":"DotActive-74b5f","DotHover":"DotHover-74b5f","PageCounter":"PageCounter-74b5f"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const Pagination = ({
  currentPage,
  totalPages,
}: {
  currentPage: number;
  totalPages: number;
}) => {
  const [hoveredPage, setHoveredPage] = useState<number | null>(null);
  const router = useRouter();
  const searchParams = Array.from(useSearchParams().entries())
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  const query = searchParams ? `?${searchParams}` : "";
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  if (totalPages < 2) {
    return null;
  }

  return (
    <div className={styles.Pagination}>
      <button
        type="button"
        className={styles.Arrow}
        onClick={() =>
          router.push(`/blog/${Math.max(currentPage - 1, 1)}${query}`)
        }
        disabled={currentPage === 1}
        aria-label="First page"
      >
        <Image src={arrowLeft} alt="First page" width={48} height={48} />
      </button>

      <div className={styles.Dots}>
        {pages.map((page) => (
          <button
            key={page}
            type="button"
            className={[
              styles.Dot,
              page === currentPage ? styles.DotActive : "",
              hoveredPage === page ? styles.DotHover : "",
            ].join(" ")}
            onClick={() => router.push(`/blog/${page}${query}`)}
            onMouseEnter={() => setHoveredPage(page)}
            onMouseLeave={() => setHoveredPage(null)}
            aria-label={`Page ${page}`}
            aria-current={page === currentPage ? "page" : undefined}
          />
        ))}
        <span className={styles.PageCounter}>
          {currentPage} | {totalPages}
        </span>
      </div>

      <button
        type="button"
        className={styles.Arrow}
        onClick={() =>
          router.push(`/blog/${Math.min(currentPage + 1, totalPages)}${query}`)
        }
        disabled={currentPage === totalPages}
        aria-label="Last page"
      >
        <Image src={arrowRight} alt="Last page" width={48} height={48} />
      </button>
    </div>
  );
};

export default Pagination;
